module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/costume_01-8e26f8deb6a9203c6947d114ace5aadc.webp";